import { defineMessages } from 'react-intl-next';

export const commonI18n = defineMessages({
	anonymous: {
		id: 'object-comments.display.name.anonymous',
		defaultMessage: 'Anonymous',
		description: 'Text used in place of a missing username',
	},
});
